// extracted by mini-css-extract-plugin
export var pressLogos = "PressCoverage-module--press-logos--6be33";
export var pressLogosImage = "PressCoverage-module--press-logos-image--5b64e";